import { useMutation, useQueryClient } from '@tanstack/react-query'

import { SellTreezService } from '@/services/sell-treez'
import { useNotify } from '@/hooks'
import { CreateIndexRequest } from '@/models/indices'

const useCreateSellTreezIndex = ({
  sellTreezId,
  onSuccess,
}: {
  sellTreezId: string
  onSuccess?(): void
}) => {
  const { notifyError, notifySuccess } = useNotify()
  const queryClient = useQueryClient()

  const create = async (data: CreateIndexRequest) => {
    const result = await SellTreezService.createSellTreezIndex(sellTreezId, data)
    return result.data
  }

  const { mutate: createIndex, isPending: isCreating } = useMutation({
    mutationFn: create,
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: ['sell-treez-indexes', sellTreezId] })
      notifySuccess('Index created successfully')
      onSuccess?.()
    },
    onError: (error) => {
      notifyError(error.message ?? 'There was an error')
    },
  })

  return { createIndex, isCreating }
}

export { useCreateSellTreezIndex }
